import { setCalendarType } from '@/slices/calendar/calendarSlice';
import { setHeaderTabsValue } from '@/slices/headerTabs/slices/headerTabsSlice';
import { TransportationEnum } from '@/utils/constants';
import { NextPage } from 'next';
import { useDispatch } from 'react-redux';
import Flight from '../flight';

const Bus: NextPage = () => {
  const dispatch = useDispatch();
  dispatch(setHeaderTabsValue(1));
  dispatch(setCalendarType({ calendarType: TransportationEnum.BUS }));
  return <Flight />;
};

export default Bus;
